import { defineComponent } from 'vue';
import { MdTypography } from '@antiqua-dls/vue-components'
import i18n from 'src/assets/i18n/i18n'

const { t } = i18n().global

export default defineComponent({
    components: {
        MdTypography
    },
    props: {
        noResultsTitle: {
            type: String,
            default: t('pages.table_no_result.title')
        },
        noResultsContent: {
            type: String,
            default: t('pages.table_no_result.body')
        },
        imgHeight: {
            type: Number,
            default: 160
        },
        imgWidth: {
            type: Number,
            default: 160
        },
        iconToShow: {
            type: String,
            default: require('components/icons/no-result-icon/no-search.svg').default
        },
        contentVariant: {
            type: String,
            default: 'body2--regular'
        },
        titleVariant: {
            type: String,
            default: 'heading6--bold'
        },
        verticalAllignment: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        
        return {
        };
    }
});